module.exports = __webpack_public_path__ + "static/media/productCategory-04.2ab63139.png";